import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const ArrowIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" {...props}>
    <path d="M13.333 7.333H5.22l3.727-3.727L8 2.667 2.667 8 8 13.333l.94-.94-3.72-3.727h8.113V7.333Z" />
  </Icon>
);

export default memo(ArrowIcon);
